import { fromUnixTimestamp } from '@/_legacy/util/UnixTimestamps';
import { t, d } from '@/ui/i18n/i18n';

export default function(group) {
  if (group.start !== null && group.end !== null) {
    if (group.end - group.start <= 60 * 60 * 24) {
      return d(fromUnixTimestamp(group.start), 'shortDate');
    }

    return `${d(fromUnixTimestamp(group.start), 'shortDate')} — ${d(fromUnixTimestamp(group.end), 'shortDate')}`;
  }

  if (group.title) {
    return group.title;
  }

  if (group.id) {
    return t('(title not set)');
  }

  return t('—');
}
